import { Link } from "react-router-dom";
import CoauthorLogo from "../../assets/favicon.ico";
import styles from "./Home.module.css";

const Home = () => {
  return (
    <main className={styles["home-page"]}>
      <div className={styles.content}>
        <img className={styles.logo} src={CoauthorLogo} alt="Coauthor Logo" />
        <h1 className={styles.title}>Coauthor</h1>
        <p className={styles.description}>
          A tool created to increase transparency in academic publishing, using
          community-sourced data.
        </p>
        <Link to="/guide" className={styles.button}>
          Get Started
        </Link>
      </div>
    </main>
  );
};

export default Home;
